  // const inputField = document.getElementById("pincodeInput");
  // const checkButton = document.getElementById("checkButton");
  // const resultDiv = document.getElementById("result");

  // function validateInput() {
  //   checkButton.disabled = inputField.value.length !== 6 || isNaN(inputField.value);
  // }

  // function saveToLocalStorage(pincode, resultHTML) {
  //   localStorage.setItem("savedPincode", pincode);
  //   localStorage.setItem("savedResult", resultHTML);
  // }

  // function loadFromLocalStorage() {
    
  //   const savedPincode = localStorage.getItem("savedPincode");
  //   const savedResult = localStorage.getItem("savedResult");

  //   if (savedPincode) {
  //     inputField.value = savedPincode;
  //     validateInput(); // Enable the button if valid
  //   }
  //   if (savedResult) {
  //     resultDiv.innerHTML = savedResult;
  //   }
  // }

  // function formatDate(dateString) {
    
  //   const date = new Date(dateString);
  //   const options = { weekday: 'long', month: 'short', day: 'numeric' };
  //   return date.toLocaleDateString('en-US', options); // E.g., "Wednesday, Dec 6";
    
  // }

  // async function checkDelivery() {
    
  //   const pincode = inputField.value.trim();

  //   if (pincode.length === 6) {

  //     checkButton.classList.add("loading");
      
  //     try {
        
  //       const response = await fetch("https://easybiznus.vercel.app/check-pincode", {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({ delivery_postcode: pincode }),
  //       });

  //       const data = await response.json();

  //       if (data.success && data.data) {
          
  //         const { estimated_delivery_time, recommended_delivery_day, delivery_city_name } = data.data;

  //         const formattedDate = formatDate(recommended_delivery_day);

  //         const resultHTML = `
  //           <div>Delivery by, <span>${formattedDate} | ${delivery_city_name}</span></div>
  //         `;

  //         resultDiv.innerHTML = resultHTML;
  //         saveToLocalStorage(pincode, resultHTML);
          
  //       } else {
          
  //         const errorHTML = `<div class="error">Delivery is not available.</div>`;
  //         resultDiv.innerHTML = errorHTML;
  //         saveToLocalStorage(pincode, errorHTML);
          
  //       }
        
  //     } catch (error) {
        
  //       console.error("Error:", error);
  //       const errorHTML = `<div class="error">Delivery is not available.</div>`;
  //       resultDiv.innerHTML = errorHTML;
  //       saveToLocalStorage(pincode, errorHTML);
        
  //     } finally {
  //       checkButton.classList.remove("loading");
  //     }
      
  //   } else {
      
  //     const errorHTML = `<div class="error">Please enter a valid pincode.</div>`;
  //     resultDiv.innerHTML = errorHTML;
  //     saveToLocalStorage(pincode, errorHTML);
      
  //   }
  // }

  // window.onload = loadFromLocalStorage;




  

  const inputField = document.getElementById("pincodeInput");
const checkButton = document.getElementById("checkButton");
const resultDiv = document.getElementById("result");

const STORAGE_KEYS = {
  PINCODE: "savedPincode",
  RESULT: "savedResult",
};

const API_URL = "https://vadhando-easybiznus.myeshopbox.com/api/v2/pincodeserviceability";
const FIXED_PICKUP_PINCODE = "425001";

const PACKAGE_DETAILS = {
  deadWeight: 500,
  length: 10,
  height: 10,
  width: 10,
};

function setResult(html) {
  resultDiv.innerHTML = html;
}

function isValidPincode(pincode) {
  return /^[0-9]{6}$/.test(pincode);
}

function validateInput() {
  const pincode = inputField.value.trim();
  checkButton.disabled = !isValidPincode(pincode);
}

function setLoading(isLoading) {
  checkButton.classList.toggle("loading", isLoading);
  checkButton.disabled = isLoading || !isValidPincode(inputField.value.trim());
}

function saveToLocalStorage(pincode, resultHTML) {
  try {
    localStorage.setItem(STORAGE_KEYS.PINCODE, pincode);
    localStorage.setItem(STORAGE_KEYS.RESULT, resultHTML);
  } catch (err) {
    console.warn("localStorage save failed:", err);
  }
}

function loadFromLocalStorage() {
  try {
    const savedPincode = localStorage.getItem(STORAGE_KEYS.PINCODE);
    const savedResult = localStorage.getItem(STORAGE_KEYS.RESULT);

    if (savedPincode && isValidPincode(savedPincode)) {
      inputField.value = savedPincode;
    }

    validateInput();

    if (savedResult) {
      setResult(savedResult);
    }
  } catch (err) {
    console.warn("localStorage load failed:", err);
    validateInput();
  }
}

function clearStoredPincodeData() {
  try {
    localStorage.removeItem(STORAGE_KEYS.PINCODE);
    localStorage.removeItem(STORAGE_KEYS.RESULT);
  } catch (err) {
    console.warn("localStorage clear failed:", err);
  }
}

function formatDate(dateString) {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-US", {
    weekday: "long",
    month: "short",
    day: "numeric",
  });
}

async function fetchWithTimeout(url, options = {}, timeout = 10000) {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeout);

  try {
    return await fetch(url, {
      ...options,
      signal: controller.signal,
    });
  } finally {
    clearTimeout(timeoutId);
  }
}

function getStandardCourier(resultArray = []) {
  if (!Array.isArray(resultArray) || resultArray.length === 0) return null;

  return resultArray.find((item) => {
    return (
      item?.courierName === "EshopboxStandard" &&
      (item?.serviceable?.PREPAID || item?.serviceable?.COD)
    );
  }) || null;
}

async function checkDelivery() {
  const pincode = inputField.value.trim();

  if (!isValidPincode(pincode)) {
    const errorHTML = `<div class="error">Please enter a valid 6-digit pincode.</div>`;
    setResult(errorHTML);
    saveToLocalStorage(pincode, errorHTML);
    validateInput();
    return;
  }

  setLoading(true);

  try {
    const response = await fetchWithTimeout(
      API_URL,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          dropPincode: pincode,
          pickupPincode: FIXED_PICKUP_PINCODE,
          deadWeight: PACKAGE_DETAILS.deadWeight,
          length: PACKAGE_DETAILS.length,
          height: PACKAGE_DETAILS.height,
          width: PACKAGE_DETAILS.width,
        }),
      },
      10000
    );

    let data;
    try {
      data = await response.json();
    } catch (err) {
      throw new Error("Invalid server response.");
    }

    if (!response.ok) {
      throw new Error(data?.message || "Unable to check delivery right now.");
    }

    const standardCourier = getStandardCourier(data?.result || []);

    if (!standardCourier) {
      const errorHTML = `<div class="error">Eshopbox Standard delivery is not available for this pincode.</div>`;
      setResult(errorHTML);
      saveToLocalStorage(pincode, errorHTML);
      return;
    }

    const {
      courierName,
      zone,
      sla,
      pickupLocation,
      serviceable,
    } = standardCourier;

    const formattedDate = formatDate(sla);
    const codAvailable = !!serviceable?.COD;
    const prepaidAvailable = !!serviceable?.PREPAID;
    const pickupAvailable = !!serviceable?.PICKUP;
    const exchangeAvailable = !!serviceable?.EXCHANGE;

    const tags = [];
    if (prepaidAvailable) tags.push("Prepaid");
    if (codAvailable) tags.push("COD");
    if (pickupAvailable) tags.push("Pickup");
    if (exchangeAvailable) tags.push("Exchange");

    const resultHTML = `
      <div class="success" style="border:1px solid #e5e7eb; padding:12px; border-radius:10px; margin-top:10px;">
        <div style="font-weight:600; margin-bottom:6px;">
          ${courierName}
        </div>
        <div style="margin-bottom:6px;">
          Delivery by <span style="font-weight:600;">${formattedDate || "Available soon"}</span>
        </div>
        
        
      </div>
    `;

    setResult(resultHTML);
    saveToLocalStorage(pincode, resultHTML);
  } catch (error) {
    console.error("Pincode check failed:", error);

    let errorMessage = "Delivery is not available right now. Please try again.";

    if (error.name === "AbortError") {
      errorMessage = "Request timed out. Please try again.";
    } else if (error.message) {
      errorMessage = error.message;
    }

    const errorHTML = `<div class="error">${errorMessage}</div>`;
    setResult(errorHTML);
    saveToLocalStorage(pincode, errorHTML);
  } finally {
    setLoading(false);
  }
}

inputField.addEventListener("input", () => {
  inputField.value = inputField.value.replace(/\D/g, "").slice(0, 6);
  validateInput();

  if (!inputField.value) {
    clearStoredPincodeData();
    setResult("");
  }
});

inputField.addEventListener("keydown", (event) => {
  if (event.key === "Enter" && !checkButton.disabled) {
    checkDelivery();
  }
});

window.addEventListener("load", loadFromLocalStorage);